import React, {useId} from 'react';

let currencies = ['AED','AUD','CAD','CHF','EUR','GBP','INR','JPY','USD'];
try { currencies = Intl.supportedValuesOf?.('currency') || currencies; } catch {}
export default function CompanyCurrencyFields({value,onChange,disabled=false}) {
  const id = useId();
  const currency = String(value.reporting_currency || '').trim().toUpperCase();
  const options = [...new Set([...currencies,...(currency ? [currency] : [])])].sort();
  const inputClass = 'mt-1 h-11 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-900';
  return <fieldset disabled={disabled} className="space-y-3 min-w-0">
    <div><label htmlFor={id+'-currency'} className="text-sm font-medium">Company reporting currency</label>
      <select id={id+'-currency'} required value={currency} className={inputClass}
        onChange={e=>onChange({...value,reporting_currency:e.target.value})}>
        <option value="">Select currency</option>{options.map(code=><option key={code} value={code}>{code}</option>)}
      </select>
      <p className="mt-1 text-xs text-gray-500">Currency for company reporting. Each unit keeps its own operating currency.</p>
    </div>
    <div><label htmlFor={id+'-country'} className="text-sm font-medium">Head office country code</label>
      <input id={id+'-country'} maxLength={2} placeholder="GB" value={value.head_office_country_code || ''}
        className={inputClass} onChange={e=>onChange({...value,head_office_country_code:e.target.value})}/>
      <p className="mt-1 text-xs text-gray-500">Optional two-letter country code.</p>
    </div>
  </fieldset>;
}
